import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import useAuth from "../../Hooks/useAuth";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/auth/login", {
        state: {
          from: location.pathname,
        },
        replace: true,
      });
    }
  }, [isLoggedIn, navigate, location]);

  return <>{children}</> || null;
}
